// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2tQsz","content":"styles_content__30060","selectAll":"styles_selectAll__2U6Tp"};